import { Injectable } from '@angular/core';

import { Credentials } from './credentials';

@Injectable()
export class AwsEnvironment {

    private credentials: Credentials;
    private iotRegion: string;
    private apiRegion: string;
    private registrationUrl: string;
    private apiUrl: string;
    private defaultSourceRegion: string;
    private signupUrl: string;
    private forgotPasswordUrl: string;
    private enableIpValidation : boolean;
    private showFreeTrial: boolean;
    private showRegCode: boolean;
    private showPromoCode: boolean;

    load(): void {
        var xhr = new XMLHttpRequest();
        xhr.onload = (ev: Event) => {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    let response = JSON.parse(xhr.responseText)
                    this.iotRegion = response['iot-region'];
                    this.apiRegion = response['apigateway-region'];
                    this.registrationUrl = 'https://' + response.registrationUrl;
                    this.apiUrl = 'https://' + response.apiUrl;
                    this.defaultSourceRegion = response['default-source-region'];
                    this.signupUrl = response['signup-url'];
                    this.forgotPasswordUrl = response['forgot-password-url'];
                    this.enableIpValidation = response['enable-ip-validation'];
                    this.showFreeTrial = response['show-free-trial'];
                    this.showRegCode = response['show-reg-code'];
                    this.showPromoCode = response['show-promo-code'];
                } else {
                    console.error(xhr.statusText);
                }
            }
        };
        xhr.onerror = (ev: Event) => {
            console.error(xhr.statusText);
        };
        xhr.open('GET', 'aws-env.json', false);
        xhr.send();
    }

    getRegistrationUrl(): string {
        return this.registrationUrl;
    }

    getApiUrl(): string {
        return this.apiUrl
    }

    getIotRegion(): string {
        return this.iotRegion;
    }

    getApiRegion(): string {
        return this.apiRegion;
    }

    getDefaultSourceRegion(): string {
        return this.defaultSourceRegion;
    }

    getCredentials(): Credentials {
        return this.credentials;
    }

    isProduction(): boolean {
        return (window.location.hostname === 'breakingpoint.cloud' || window.location.hostname === 'www.breakingpoint.cloud')
    }

    /*
    isSandbox(): boolean {
        return (window.location.hostname === 'ixia-sandbox.cloud' || window.location.hostname === 'www.ixia-sandbox.cloud')
    }
    */

    setCredentials(accessKeyId: string, secretAccessKey: string, sessionToken: string, expireDate: Date) {
        this.credentials = new Credentials();
        this.credentials.accessKeyId = accessKeyId;
        this.credentials.secretAccessKey = secretAccessKey;
        this.credentials.sessionToken = sessionToken;
        this.credentials.expireDate = expireDate;
    }

    clearCredentials() {
        this.credentials = null;
    }

    getSignupUrl(): string {
        return this.signupUrl;
    }

    getForgotPasswordUrl(): string {
        return this.forgotPasswordUrl;
    }

    isIpValidationEnabled(): boolean {
        return this.enableIpValidation;
    }

    getShowFreeTrial(): boolean {
        return this.showFreeTrial;
    }

    getShowRegCode(): boolean {
        return this.showRegCode;
    }

    getShowPromoCode(): boolean {
        return this.showPromoCode;
    }
}

export function createAwsEnv() {
    let awsEnv = new AwsEnvironment();
    awsEnv.load();
    return awsEnv
};



// WEBPACK FOOTER //
// ./src/app/aws/environment.ts